// extracted by mini-css-extract-plugin
export default {"alignVerticalFull":"alignVerticalFull--n4VDB","layoutPadding":"layoutPadding--V7EaD","layoutConfiguration":"layoutConfiguration--SH53M","contentStyle":"contentStyle--OL3pG"};